import { inject } from '@angular/core';
import { CanActivateFn, GuardResult, MaybeAsync } from '@angular/router';
import { filter, map } from 'rxjs';
import { LazyLoadedClassService } from '../services';

/**
 * @author Jesse Rogers <jesse.rogers@adaptiva.com>
 * @description Prevents views from loading before lazy loading service has completed
 * 	asynchronous loading tasks.
 */
export const lazyLoadingGuard: CanActivateFn = (): MaybeAsync<GuardResult> => {
	const _lazyLoader: LazyLoadedClassService = inject(LazyLoadedClassService);

	_lazyLoader.load();

	return _lazyLoader.isLoading.pipe(
		filter((_isLoading: boolean) => !_isLoading),
		map((_isLoading: boolean) => !_isLoading),
	);
};
